import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

/* ── Methodology ticker ──────────────────────────────────────────────────── */
const TICKER_ITEMS = [
  "GHG Protocol Scope 3 — Category 1",
  "PCAF Standard Compatible",
  "EXIOBASE MRIO Database",
  "Spend-Based Emission Factors",
  "RBI Climate Risk Disclosure Guidelines",
  "SEBI BRSR Supply-Chain Reporting",
  "EU CSRD Scope 3 Aligned",
  "CBAM Carbon Border Risk",
];

function ComplianceTicker() {
  const doubled = [...TICKER_ITEMS, ...TICKER_ITEMS];
  return (
    <div className="compliance-ticker">
      <div className="compliance-ticker-label">METHODOLOGY</div>
      <div className="compliance-ticker-track-wrap">
        <div className="compliance-ticker-track">
          {doubled.map((item, i) => (
            <span key={i} className="compliance-ticker-item">
              <span className="compliance-ticker-dot" />
              {item}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

/* ── Nav ─────────────────────────────────────────────────────────────────── */
const NAV_ITEMS = [
  { id: "methodology",  label: "Methodology" },
  { id: "how-it-works", label: "How It Works" },
  { id: "outputs",      label: "Outputs" },
  { id: "governance",   label: "Governance" },
  { id: "access",       label: "Access" },
];

export default function LandingNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [atTop,    setAtTop]    = useState(true);

  useEffect(() => {
    function onScroll() {
      const y = window.scrollY;
      setScrolled(y > 40);
      setAtTop(y < 10);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  function scrollTo(id) {
    setMenuOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  }

  return (
    <>
      <ComplianceTicker />

      <nav className={`landing-nav${scrolled ? " scrolled" : ""}${atTop ? " at-top" : ""}`}>
        <Link to="/" className="landing-nav-brand">
          <img src="/rs-logo.png" alt="GreenSetu" />
          <div className="landing-nav-brand-text">
            <span className="lnb-name">GreenSetu</span>
            <span className="lnb-sub">Carbon Risk Screening</span>
          </div>
        </Link>

        <div className="landing-nav-links">
          {NAV_ITEMS.map(({ id, label }) => (
            <button key={id} className="landing-nav-link" onClick={() => scrollTo(id)}>
              {label}
            </button>
          ))}
        </div>

        <div className="landing-nav-spacer" />

        <div className="landing-nav-actions">
          <Link to="/login" className="landing-nav-login">Sign in</Link>
          <Link to="/login" className="landing-nav-cta">Start Screening</Link>
        </div>

        <button
          className="landing-nav-burger"
          aria-label="Toggle menu"
          onClick={() => setMenuOpen((o) => !o)}
        >
          {menuOpen ? <X size={22} /> : <><span /><span /><span /></>}
        </button>
      </nav>

      <div className={`landing-nav-mobile${menuOpen ? " open" : ""}`}>
        {NAV_ITEMS.map(({ id, label }) => (
          <button key={id} className="landing-nav-mobile-link" onClick={() => scrollTo(id)}>
            {label}
          </button>
        ))}
        <Link to="/login" className="landing-nav-mobile-link">Sign in</Link>
        <Link to="/login" className="mobile-cta">Start Screening →</Link>
      </div>
    </>
  );
}
